<template>
    <div class="unicon">
        <svg
            xmlns="http://www.w3.org/2000/svg"
            :width="getSize"
            :height="getSize"
            viewBox="0 0 24 24"
            :fill="fill"
            @click="$emit('click')"
            v-html="icon"
        />
    </div>
</template>


<script>

    export default {
        name: 'Unicon',

        props: {
            name: {
                type: String,
                default: ''
            },
            iconStyle: {
                type: String,
                default: 'line'//or monochrome
            },
            fill: {
                type: String,
                default: 'currentColor'
            },
            size:{
                type: String,
                default: 'default'
            }
        },

        computed: {
            icon () {
                const icon = window.icons.icons.find(
                    i => i.name === this.name && i.style === this.iconStyle
                );

                if (icon) {
                    return icon.path
                } else {
                    console.error('Name of the icon is not correct: ' + this.name);
                    return undefined
                }
            },
            getSize(){
                switch (this.size) {
                    case 'default':
                        return 20;
                    case 'sm':
                        return 15;
                    case 'xs':
                        return 12;
                    case 'lg':
                        return 24;
                }
            }
        }
    }
</script>

<style>
    .unicon {
        display: inline-block;
        fill: currentColor;
        vertical-align: -.2rem;
    }
</style>
